export default {
  register: {
    method: "post",
    url: "/agent/v1/register",
  },
  update: {
    method: "put",
    url: "/agent/v1/users/:id",
  },
  delete: {
    method: "delete",
    url: "/agent/v1/users/:id",
  },
  agentList: {
    method: "get",
    url: "/agent/v1/users",
  },
  detail: {
    method: "get",
    url: "/agent/v1/users/:id",
  },
};
